import { axios } from "@Root/API";

export const getModulesDelivery = (moduleId, params) => {
  return axios.get(`delivery-modules/${moduleId}`, { params });
};
